const portalId = "21482779";
const formGuid = "57020148-ff66-47d8-ad81-4f172b17b81c";
const config = {
  url: `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`,
  validate: "https://dev.ms.sandbox-metafinanciera.com/leadsdigital/validate",
  insert: "https://dev.ms.sandbox-metafinanciera.com/leadsdigital/leads/insert",
  curpUrl: "https://dev.ms.sandbox-metafinanciera.com/procesometadata/api/validateCurpNubarium",
  blackList: "https://dev.ms.sandbox-metafinanciera.com/originacioncredito/api/validaListaNegraNew",
  businessRules: "https://dev.ms.sandbox-metafinanciera.com/procesometadata/api/validateBusinessRule"
};

export default config;
